import { toast } from 'react-toastify';
import { bannerTypeApi } from 'widgets/content/ui/banner-type/api/bannerTypeApi';

type BannerType = {
  id: number | 0;
  title: string | null;
};

const BannerTypeController = bannerTypeApi.injectEndpoints({
  endpoints: (builder) => ({
    getBannerType: builder.query<BannerType[], any>({
      query: () => ({
        url: '/news-pages/admin/banner-types',
      }),
      providesTags: ['Banner'],
    }),
    createBannerType: builder.mutation({
      query: (form) => ({
        url: '/news-pages/admin/banner-types',
        method: 'POST',
        body: form,
        headers: {
          'content-type': 'application/json',
        },
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = 'Произошла ошибка при создании типа баннера';
        if (error) {
          toast.error(error_message.toString(), {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно создали новый тип баннера', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'Response', id: arg.id },
          { type: 'Response', id: 'ALL' },
        ];
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetBannerTypeQuery, useCreateBannerTypeMutation } = BannerTypeController;
